<template>
  <div class="bg-white">
    <FilePond
      :name="internalOptions.name"
      ref="pond"
      :label-idle="internalOptions.labelIdle"
      :allow-multiple="internalOptions.allowMultiple"
      :allow-revert="false"
      :accepted-file-types="internalOptions.acceptedFileTypes"
      :instant-upload="true"
      :chunk-uploads="internalOptions.chunkUploads"
      :chunk-size="internalOptions.chunkSize"
      :server="serverOptions"
      credits="false"
      @processfile="onProcessFile"
      @processfiles="onProcessFiles"
    />
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import { getCookie } from '@/utils/helpers';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

const defaultOptions = {
  name: 'file',
  labelIdle: "Drop files here or <span class='underline cursor-pointer'>Browse</span> to upload",
  acceptedFileTypes: 'image/*',
  allowMultiple: false,
  chunkUploads: true,
  chunkSize: 1000000,
};

export default {
  components: {
    FilePond,
  },
  props: {
    value: {
      type: [Array],
      default: null,
    },
    options: {
      type: Object,
      default: () => ({ ...defaultOptions }),
    },
  },
  data() {
    return {
      internalOptions: this.getOptions(),
      serverOptions: {
        process: {
          url: '/api/v1/upload',
          method: 'POST',
          withCredentials: true,
          onerror: null,
          headers: {
            'X-Xsrf-Token': getCookie('XSRF-TOKEN'),
          },
        },
        patch: {
          url: '/api/v1/upload?patch=',
          method: 'PATCH',
          withCredentials: true,
          headers: {
            'X-Xsrf-Token': getCookie('XSRF-TOKEN'),
          },
        },
        revert: null,
        restore: null,
        load: null,
        fetch: null,
      },
    };
  },
  methods: {
    getOptions() {
      return {
        ...defaultOptions,
        ...this.options,
      };
    },
    async onProcessFile(error, file) {
      if (error) {
        this.$emit('error', ErrorEvent);
        return;
      }

      this.$emit('file-uploaded', file.serverId);

      this.$refs.pond.removeFile(file.id);
    },
    onProcessFiles() {
      this.$emit('upload-completed');
    },
  },
};
</script>
